<template>
    <div class="bid-input-buttons">
        <button
            type="button"
            class="bid-input-buttons__button btn btn-outline-primary"
            @click="decrease"
            @mousedown="onLongDecrease"
            @mouseup="onLongPressStop"
        >
            <span> - </span>
        </button>

        <BidInput :value="value" @input="onInput" class="bid-input-buttons__input" />

        <button
            type="button"
            class="bid-input-buttons__button btn btn-outline-primary"
            @click="increase"
            @mousedown="onLongIncrease"
            @mouseup="onLongPressStop"
        >
            <span> + </span>
        </button>
    </div>
</template>

<script>
import BidInput from '@/components/product/auction/BidInput.vue';

export default {
    name: 'BidInputWithButtons',
    components: { BidInput },

    data() {
        return {
            intervalId: null
        };
    },

    props: {
        value: {
            required: true
        },
        longIntervalMS: {
            type: Number,
            default: 200
        }
    },
    methods: {
        onLongIncrease() {
            this.intervalId = setInterval(() => {
                this.increase();
            }, this.longIntervalMS);
            return false;
        },
        onLongDecrease() {
            this.intervalId = setInterval(() => {
                this.decrease();
            }, this.longIntervalMS);
            return false;
        },
        onLongPressStop() {
            clearInterval(this.intervalId);
            return false;
        },
        decrease() {
            this.onInput(Math.max(0, +this.value - 100));
        },
        increase() {
            this.onInput(+this.value + 100); //+this.value to force it to number (when getting it from query string) to prevent +1 as string concat
        },
        onInput(amount) {
            this.$emit('input', amount);
        }
    }
};
</script>

<style scoped lang="scss">
.bid-input-buttons {
    display: flex;
    flex-wrap: nowrap;
    gap: 0.5rem;
    align-items: center;
    min-width: 220px;

    &__button {
        font-weight: 700;
        line-height: 1;
        padding: 10px;
        flex: 1 0 2.5em;
        font-size: 1.125em;
        aspect-ratio: 1;
    }
}
</style>
